var map = {
	"./en/1.png": 2321,
	"./en/2.png": 2322,
	"./en/3.png": 2323,
	"./en/4.png": 2324,
	"./en/5.png": 2325,
	"./ru/1.png": 2326,
	"./ru/2.png": 2327,
	"./ru/3.png": 2328,
	"./ru/4.png": 2329,
	"./ru/5.png": 2330
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2320;


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info ^\.\/.*$
// module id = 2320
// module chunks = 0